var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "row mb-2" }, [
        _c(
          "div",
          {
            staticClass: "col-6",
            on: {
              click: function($event) {
                _vm.$emit("close")
              }
            }
          },
          [_vm._m(0)]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "col-6 flex justify-content-end" }, [
          _c(
            "a",
            {
              staticClass: "mark-all-read",
              attrs: { href: "#" },
              on: { click: _vm.markAllAsRead }
            },
            [_vm._v("\n        Mark all as read\n      ")]
          )
        ])
      ]),
      _vm._v(" "),
      _vm.notifications === null
        ? [_vm._m(1)]
        : _vm.notifications && _vm.notifications.length
          ? [
              _c("div", [
                _c(
                  "div",
                  { staticClass: "notification-wrap mt-2" },
                  _vm._l(_vm.groupedNotifications, function(
                    notification,
                    index
                  ) {
                    return _c("NotificationGroup", {
                      key: index,
                      attrs: { notifications: notification },
                      on: {
                        close: function($event) {
                          _vm.$emit("close")
                        }
                      }
                    })
                  })
                )
              ])
            ]
          : [_vm._m(2)]
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h1", { staticClass: "modal-h1 mb-3" }, [
      _c("span", { staticClass: "btn btn-back" }),
      _vm._v("\n        Notifications\n      ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "lds-ellipsis px-4 py-4" }, [
      _c("div"),
      _vm._v(" "),
      _c("div"),
      _vm._v(" "),
      _c("div")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "notification-wrap mt-2" }, [
      _c("span", [
        _vm._v("\n        There are no notifications right now.\n      ")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-43a3e4e8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43a3e4e8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Notifications.vue
// module id = null
// module chunks = 